import { useParams } from "react-router-dom";

//API calls
import { useGetProjectSplosnoDetails } from "../../../services/ProjectDetails/splosnoAPI";

//utils
import formatDateHelper from "../../utils/dateFormat";
import setTextForBooleanOrNull from "../../utils/setTextForBooleanOrNull";
import tooltipsText from "../../utils/tooltipsText";

//bootstrap
import { Row, Col } from "react-bootstrap";

//ui componentes
import Field from "../../ui/Field";
import FieldPodrocja from "../../ui/FieldPodrocja";
import FieldProgrami from "../../ui/FieldProgrami";

const SplosnoDetails = () => {
  const { id } = useParams();
  const { data: project, isLoading } = useGetProjectSplosnoDetails(id);

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <p>Nalaganje splošnih podatkov...</p>
      </div>
    );
  }

  return (
    <div>
      {/* ── Osnovni podatki ── */}
      <h6 className="form-section-heading">Osnovni podatki</h6>
      <Row className="mb-2">
        <Col md={12}>
          <Field label="Naslov projekta" value={project?.naziv} />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6}>
          <Field label="Akronim projekta" value={project?.akronim} />
          <Field label="Šifra projekta" value={project?.sifra} />
        </Col>
        <Col md={6}>
          <Field
            label="Začetek projekta"
            value={formatDateHelper(project?.zacetek)}
          />
          <Field
            label="Konec projekta"
            value={formatDateHelper(project?.konec)}
          />
        </Col>
      </Row>

      <hr className="form-section-divider" />

      {/* ── Pogodba in sodelovanje ── */}
      <h6 className="form-section-heading">Pogodba in sodelovanje</h6>
      <Row className="mb-4">
        <Col md={6}>
          <Field
            label="Naslov in številka pogodbe"
            value={project?.pogodba}
            tooltip={tooltipsText.P2naslovPogodbe}
          />
          <Field label="Referenčna številka" value={project?.referencnaSt} />
          <Field label="Spletna stran projekta" value={project?.spletnaStran} />
        </Col>
        <Col md={6}>
          <Field
            label="Deminimis"
            value={setTextForBooleanOrNull(project?.deminimis)}
          />
          <Field
            label="Sodelovanje z gospodarstvom"
            value={setTextForBooleanOrNull(project?.sodGopodarstvom)}
          />
          <Field
            label="Sodelovanje s študenti"
            value={setTextForBooleanOrNull(project?.sodStudenti)}
          />
          {project?.sodStudenti && (
            <Field
              label="Število sodelujočih študentov"
              value={project?.stStudenti}
            />
          )}
          <Field
            label="Enakost spolov"
            value={setTextForBooleanOrNull(project?.enakostSpolov)}
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={12}>
          <Field label="Opis projekta" value={project?.povzetek} />
        </Col>
      </Row>

      <hr className="form-section-divider" />

      {/* ── Občanska znanost ── */}
      <h6 className="form-section-heading">Občanska znanost</h6>
      <Row className="mb-4">
        <Col md={6}>
          <Field
            label="Občanska znanost"
            value={setTextForBooleanOrNull(project?.obcanskaZnanost)}
            tooltip={tooltipsText.SplosnoObcanskaZnanost}
          />
          {project?.obcanskaZnanost == true && (
            <>
              <Field
                label="Projekt občanske znanosti je vezan na drug (krovni) projekt"
                value={setTextForBooleanOrNull(
                  project?.obcanskaZnanostKrovniProjekt,
                )}
              />
              {project?.obcanskaZnanostKrovniProjekt == true && (
                <Field
                  label="Naziv krovnega projekta"
                  value={project?.obcanskaZnanostNazivProjekt}
                />
              )}
            </>
          )}
        </Col>
      </Row>

      <hr className="form-section-divider" />

      {/* ── Razpis in klasifikacije ── */}
      <h6 className="form-section-heading">Razpis in klasifikacije</h6>

      <Row>
        <Col md={12}>
          <Field label="Razpis" value={project?.razpis} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FieldProgrami
            label="Program (struktura)"
            programi={project?.programi}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FieldPodrocja
            label="Področja"
            arrs={project?.arrs}
            cerif={project?.cerif}
            klasius={project?.klasius}
          />
        </Col>
      </Row>

      <hr className="form-section-divider" />

      {/* ── Datum vnosa ── */}
      <Row className="mb-3">
        <Col md={6}>
          <Field
            label="Datum vnosa projekta"
            value={formatDateHelper(project?.timestamp)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SplosnoDetails;
